// Defoalt is for SECONDARY SCHOOLS API
export const environment = {
  // baseUrl: 'https://api.ebill.so:3355/api',
  // url: 'https://api.ebill.so:3355/',

  //gambool
  
  baseUrl: 'https://api.ebill.so:3357/api',
  url: 'https://api.ebill.so:3357/',
  production: true
};